import MailingFilesStelaModalView from '../../mailings/mailingFilesStelaModal.html';
import SearchPersonsModalView from '../../notifications/searchPersonsModal.html';


angular.module('notifications')

    .controller('NotificationsMailCtrl', ['$scope', '$uibModalInstance', '$uibModal', '$http', 'options', 'Restangular', '$filter', 'LoginService', 'Upload', 'modalService', 'generateDocumentService', 'BeeService', 'logService',
        function ($scope, $uibModalInstance, $uibModal, $http, options, Restangular, $filter, LoginService, Upload, modalService, generateDocumentService, BeeService, logService) {

        $scope.mail = options.params;
        $scope.mail.files = [];
        $scope.mail.filesToShow = [];
        $scope.mail.attachments = [];
        $scope.mailings = [];
        $scope.params = [];
        $scope.mail.notificationAttachments = []; // esto es para guardar lo nuevo, voy a ver como llega.
        $scope.showRecipientList = false;
        $scope.showICS = false;
        $scope.blocked_all = false;
        $scope.disabled_account = false;
        $scope.mail.scheduled_date = null;
        $scope.loadBee = true;
        $scope.showDateScheduleError = false;
        BeeService.start({});

        $scope.mail.preheader = "[EVENT_NAME] [EVENT_DATE]";

        $scope.mail.ics = 0;

        if ($scope.mail.entity_type == "events") {
            $scope.showICS = true;
        }

        $scope.showToPart = true;

        if ($scope.mail.event_guests_ids != null || $scope.mail.persons_ids != null || $scope.mail.users_ids != null || $scope.mail.event_staffs_ids != null || $scope.mail.event_users_ids != null) {
            $scope.showToPart = false;
            $scope.totalEmails = ($scope.mail.event_guests_ids != null ? $scope.mail.event_guests_ids.length : 0) +
                ($scope.mail.persons_ids != null ? $scope.mail.persons_ids.length : 0) +
                ($scope.mail.users_ids != null ? $scope.mail.users_ids.length : 0) +
                ($scope.mail.event_staffs_ids != null ? $scope.mail.event_staffs_ids.length : 0) +
                ($scope.mail.event_users_ids != null ? $scope.mail.event_users_ids.length : 0);
        }

        $scope.message = $scope.mail.message;
        $scope.replyMailsAccounts = [];
        var user_mail = "";

        $scope.loadCombos = function () {
            //Cuentas de correo
            Restangular.all('MailAccounts').getList().then(function (accounts) {
                $scope.mailsAccounts = accounts;

                if ($scope.mail.entity_type == "events") {
                    $scope.disabled_account = true;
                } else {
                    // Si hay una cuenta definida como cuenta por defecto, la marcamos.
                    let defaultAccount = accounts.filter(m => m.use_by_default)[0];
                    if (defaultAccount != null && $scope.mail.mail_account_id == null) $scope.mail.mail_account_id = defaultAccount.id;
                }
                $scope.changeReplies(true);
            });                
            
            //Cuenta del usuario
            Restangular.one('Users/Mail', LoginService.get("userId")).get().then(function (mail) {
                user_mail = mail;
            });

            //Templates
            Restangular.all('NotificationsTemplates').customGET("LoadTemplatesForSelect").then(function (templates) {
                $scope.templates = templates;
                $scope.templates.unshift({
                    id: null,
                    name: $filter('translate')('events.no_template')
                });
                $scope.mail.template_id = null;
            });

            $scope.params.entity_type = (options.params.entity_type != null ? options.params.entity_type : null);
            $scope.params.entity_type_id = (options.params.entity_type_id != null ? options.params.entity_type_id : null);
            switch ($scope.params.entity_type) {
                case "persons":
                case "users":
                    $scope.params.entity_type = null;
                    if (options.params.app_enabled) {
                        $scope.params.mailing_type_code = 'QR_GUEST_USER_REGISTRATION,PERSONS';
                    } else {
                        $scope.params.mailing_type_code = 'PERSONS';
                    }
                    break;
                case "events":
                    $scope.params.mailing_type_code = 'EVENTS';
                    break;
                case "program":
                    $scope.params.entity_type = null;
                    $scope.params.mailing_type_code = 'PROGRAM';
                    $scope.isProgramMail = true;
                    break;
                case "accreditation_staff":
                    $scope.params.entity_type = null;
                    $scope.params.mailing_type_code = 'ACCREDITATION_STAFF';
                    break;
                default:
                    $scope.params.mailing_type_code = 'EVENTS';
            }

            Restangular.all('Mailings').getList($scope.params).then(function (templates) {

                $scope.mailings = templates;

                /*
                Si es de programa, lo metemos automáticamente
                if ($scope.params.entity_type = 'PROGRAM') $scope.mailingChange(templates[0].id)
                */ 

            })

            // Modelos de adjuntos (depende de lo que se le pase por parametros.)

            $scope.showDocuments = true;
            if (typeof ($scope.mail.documents) === "undefined") {
                $scope.showDocuments = false;
            } else {
                var optionsValues = {
                    entity_type: (options.params.entity_type != null ? options.params.entity_type : null),
                    entity_type_id: (options.params.entity_type_id != null ? options.params.entity_type_id : null),
                    codes: $scope.mail.documents.codes,
                    for_event_guest: $scope.mail.documents.for_event_guest,
                    for_event_staff: $scope.mail.documents.for_event_staff,
                    for_event_workteam: $scope.mail.documents.for_event_workteam,
                    for_correspondence: $scope.mail.documents.for_correspondence
                };
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + 'Documents/GetDocumentsByDocumentsType',
                    params: optionsValues
                }).then(function (results, status, headers, config) {
                    $scope.documents = results.data.rows;
                    $scope.documentsTypes = $scope.documents.map(function (item) { return { code: item.FK_documents_documents_types.code, name: item.FK_documents_documents_types.name } }).filter(function (x, i, a) {
                        return a.findIndex(m => m.code === x.code) == i;
                    });
                });
            }
        }

        $scope.loadCombos();

        var languageCode = "es"; //$translate.use().toLowerCase();
        $scope.tinymceOptions = {

            resize: true,
            forced_root_block: false,
            relative_urls: false,
            convert_urls: false,
            remove_script_host: false,
            contextmenu: false,
            branding: false,
            height: 100,
            body_class: 'custom_tinymce_content',
            //valid_classes: 'razor_expression',
            language: languageCode,
            paste_as_text: true,
            plugins: 'paste autoresize textcolor image lists advlist table noneditable code link fullpage',
            toolbar: "undo redo | alignleft aligncenter alignright alignjustify | bold italic forecolor backcolor fontsizeselect | bullist numlist outdent indent link | image | code",
            menubar: false,
            statusbar: false

        };

        $scope.options = options;

        $scope.changeReplies = function (firstime) {

            if (typeof firstime === 'undefined') firstime = false;
            $scope.replyMailsAccounts = [];
            var reply_to = $scope.mail.mail_account_reply;

            if ($scope.mail.entity_type == "events" && $scope.mail.entity_type_id != null) {
                Restangular.one('Events', $scope.mail.entity_type_id).get().then(function (event) {
                    $scope.parent_event = event;
                    $scope.mail.cco_tmp = event.bcc;
                });
            }

            if ($scope.mailsAccounts != null && typeof ($scope.mailsAccounts) !== 'undefined' && $scope.mail.mail_account_id != null && typeof ($scope.mail.mail_account_id) !== 'undefined') {

                if (!firstime) { 
                    console.log('scope.parent_event', $scope.parent_event);
                    // Si es la misma cuenta que la definida el evento, sacamos el reply_to de esa cuenta, si no, dejamos el que ya tenía el mail (que puede ser el del evento o el del mailing)
                    if (typeof ($scope.parent_event) !== 'undefined' && $scope.parent_event.mail_account_id == $scope.mail.mail_account_id && $scope.parent_event.reply_to != null) {
                        reply_to = $scope.parent_event.reply_to;
                    } else {
                        reply_to = $scope.mailsAccounts.find(account=> $scope.mail.mail_account_id == account.id).reply_to; 
                    } //solo si cambia el combo
                }
            }

            $scope.mail.from = $scope.replyMailsAccounts[0];
            $scope.mail.reply_to = reply_to;
            $scope.replyMailsAccounts.push(user_mail);

        };

        $scope.newAttachment = function (file) {
            if (file != null) {
                Restangular.all("FilesTypesWhitelist").customGET("GetTotalSizeAllowed", { entity: "mailings" }).then(function (result) {
                    if (result.filter(e => e.type === file.type).length <= 0) {
                        var typeAllowed = result.map(o => o.type).join(', ');
                        modalService.message({
                            title: "Error",
                            message: "File: " + file.type + "<br><br>" + $filter('translate')('general.type_file_not_allowed') + "<br>" + typeAllowed,
                            onAccept: function () { }
                        });
                    } else {
                        var maxSizeAllowed = result.find(e => e.type === file.type).maxsize;
                        var sizeFileMB = file.size / 1024;
                        if (sizeFileMB > 0) {
                            //Comprobamos que no pase del tamaño limite de imagen
                            if (sizeFileMB > maxSizeAllowed) {
                                modalService.message({
                                    title: "Error",
                                    message: "File: " + sizeFileMB.toFixed(2) + "<br><br>" + $filter('translate')('general.image_size_limit') + "<br>" + maxSizeAllowed + " Kb",
                                    onAccept: function () { }
                                });
                            } else {
                                $scope.mail.files.unshift(file);
                                $scope.mail.filesToShow.unshift(file);
                            }
                        }
                    }
                })
            }
        };

        // Response del modal

        $scope.newAttachmentStela = function () {

            $scope.$modalInstance = $uibModal.open({
                animation: true,
                template: MailingFilesStelaModalView,
                size: "lg",
                controller: "MailingFilesStelaModalCtrl",
                scope: $scope,
                resolve: {
                    entity_type: function () { return $scope.mail.entity_type },
                    entity_type_id: function () { return $scope.mail.entity_type_id != null ? $scope.mail.entity_type_id : null; },
                    is_public: function () { return false; },
                    folderId: function () { return null; }
                }

            });

            // Response del modal
            $scope.$modalInstance.result.then(function (data) {
                if (data.length > 0) {
                    angular.forEach(data, function (row) {

                        $scope.mail.filesToShow.push({
                            name: row.filename,
                            type: row.mimetype
                        });

                        var fileStela = {
                            name: row.filename,
                            file_id: row.id,
                            mimetype: row.mimetype,
                            uid: row.uid
                        }

                        $scope.mail.attachments.push(fileStela);

                    })
                }

            }, function () {

            });

        };

        $scope.deleteAttachment = function (item) {

            var index = $scope.mail.files.indexOf(item);
            $scope.mail.files.splice(index, 1);
            index = $scope.mail.filesToShow.indexOf(item);
            $scope.mail.filesToShow.splice(index, 1);

        };
        $scope.onAccept = function () {

            if (angular.isUndefined($scope.mail.addresses)) $scope.mail.addresses = "";
            if (angular.isUndefined($scope.mail.cc_tmp)) $scope.mail.cc_tmp = "";
            if (angular.isUndefined($scope.mail.cco_tmp)) $scope.mail.cco_tmp = "";

            if ($scope.mail.addresses == "" && $scope.mail.cc_tmp == "" && $scope.mail.cco_tmp == "" && $scope.showToPart) {
                $scope.message = $filter('translate')('mail.missing_mail_to_cco_cc');
            } else {
                if (angular.isDefined($scope.mail.addresses) && $scope.mail.addresses != "" && $scope.mail.addresses != null)
                    $scope.mail.to = $scope.mail.addresses.split(",");
                if (angular.isDefined($scope.mail.cc_tmp) && $scope.mail.cc_tmp != "" && $scope.mail.cc_tmp != null)
                    $scope.mail.cc = $scope.mail.cc_tmp.split(",");
                if (angular.isDefined($scope.mail.cco_tmp) && $scope.mail.cco_tmp != "" && $scope.mail.cco_tmp != null)
                    $scope.mail.cco = $scope.mail.cco_tmp.split(",");

                if ($scope.mail.files.length > 0) {
                    Upload.base64DataUrl($scope.mail.files).then(function (urls) {
                        for (var i = 0; i < urls.length; i++) {
                            $scope.mail.attachments.push({
                                name: $scope.mail.files[i].name,
                                file_id: $scope.mail.files[i].file_id,
                                content: urls[i]
                            })
                        }
                        confirmSend();
                    });
                    
               } else {
                    confirmSend();
               }
            }


        };
        var confirmSend = function () {
            //Marcamos en este punto si se trata de una invitacion o no (para poner correctamente el icono de error,enviado de invitaciones)
            /*
                Hay varias combinaciones para saber que es invitacion:
                    1. Se selecciona una plantilla que sea de tipo invitacion
                    2. Se adjunta un informe que sea de tipo invitacion.
                    3. Se selecciona una comunicación que tenga una plantilla de tipo invitacion
                    4. Se selecciona una comunicacion que tenga un adjunto de tipo invitacion
            */
            if ($scope.options.template != null && $scope.options.template.is_invitation) {
                //opcion 1 y opcion 3
                $scope.mail.mark_as_sent_invitation = true;
            }

            if ($scope.options.params.notificationAttachments.length > 0 && $scope.options.params.notificationAttachments.find(row => row.entity_type === "INVITATION") !=null ) {
                //opcion 2 y opcion 4
                $scope.mail.mark_as_sent_invitation = true;
            }

            if ($scope.loadBee) {
                BeeService.save().then(function (result) {
                    $scope.mail.json = result.json;
                    $scope.mail.content = result.html;
                    send();
                });
            } else {
                send();
            }
        };

        var send = function () {

            var isAllCorrect = true;

            if ($scope.mail.scheduled_date != null) {
                $scope.mail.scheduled_date = new Date($scope.mail.scheduled_date);        
                let today = new Date();
                var days = Math.round(($scope.mail.scheduled_date.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

                if ($scope.mail.scheduled_date.getTime() < today.getTime()) {
                    isAllCorrect = false;
                }
            }
            
            if (angular.isUndefined($scope.mail.from) || $scope.mail.from == null) {
                $scope.mail.from = $scope.mailsAccounts.find(account => $scope.mail.mail_account_id == account.id).email;
            }

            if (isAllCorrect) {
                $http({
                    method: 'post',
                    url: (window as any).CONFIG.api_url + 'NotificationsEmails/SendMail',
                    data: $scope.mail
                }).then(function (results, status, headers, config) {
                    $uibModalInstance.close(true);
                });
            } else {
                $scope.showDateScheduleError = true;
            }
        };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.openSearchPerson = function (whereToAdd) {
            $scope.$modalInstance = $uibModal.open({
                animation: true,
                template: SearchPersonsModalView,
                size: "lg",
                controller: "searchPersonsModalCtrl",
                scope: $scope,
                resolve: {
                    options: function () {
                        return {};
                    }
                }
            });

            // Response del modal
            $scope.$modalInstance.result.then(function (data) {
                var mailsSelected = "";
                angular.forEach(data, function (row) {
                    mailsSelected = (mailsSelected != "" ? mailsSelected + "," + row : row);
                });
                if (whereToAdd == "addresses") {
                    $scope.mail.addresses = (typeof ($scope.mail.addresses) !== 'undefined' && $scope.mail.addresses != "" ? $scope.mail.addresses + "," + mailsSelected: mailsSelected);
                } else if (whereToAdd == "cc_tmp") {
                    $scope.mail.cc_tmp = (typeof ($scope.mail.cc_tmp) !== 'undefined' && $scope.mail.cc_tmp != "" ? $scope.mail.cc_tmp + "," +mailsSelected: mailsSelected);
                } else if (whereToAdd == "cco_tmp") {
                    $scope.mail.cco_tmp = (typeof ($scope.mail.cco_tmp) !== 'undefined' && $scope.mail.cco_tmp != "" ? $scope.mail.cco_tmp + "," +mailsSelected: mailsSelected);
                }
                if (!$scope.$$phase) $scope.$apply();
            }, function () {
                console.info('Modal dismissed at: ' + new Date());
                if (!$scope.$$phase) $scope.$apply();
            });
        };

        $scope.loadTemplate = function (template_id) {
            if (typeof (template_id) !== "undefined" && template_id !== null && template_id !== "") {
                if (options.params.entity_type === "events") {
                    Restangular.one('Templates', template_id).get().then(function(result) {
                        $scope.options.template = result;
                    });
                    Restangular.all("NotificationsTemplates").customGET("LoadTemplateFromEmailsFromEvent", { event_id: options.params.entity_type_id, template_id: template_id }).then(function (res) {
                        if (res.content!=null && res.content !== "" && typeof (res.content) !== "undefined") {
                            $scope.mail.content = res.content;
                            if (res.json != null && res.json !== "") {
                                $scope.loadBee = true;
                                BeeService.reload(JSON.parse(res.json));
                            } else {
                                $scope.loadBee = false;
                            }
                        } else {
                            $scope.reloadTemplate(template_id);
                        }
                    });
                } else {
                    $scope.reloadTemplate(template_id);
                }
            } else {
                $scope.mail.content = "";
            }
        }

        $scope.reloadTemplate = function (template_id) {
            if (typeof (template_id) !== "undefined" && template_id !== null && template_id !== "") {

                Restangular.all("NotificationsTemplates").customGET("LoadTemplate", { template_id: template_id }).then(function (res) {
                    if (res !== "" && typeof (res) !== "undefined") {
                        if (res.json != null) {
                            $scope.loadBee = true;
                            BeeService.reload(JSON.parse(res.json));
                            $scope.mail.content = res.html;
                            $scope.mail.json = res.json;
                        } else {
                            $scope.loadBee = false;
                            $scope.mail.content = res.html;
                        }                        
                    } else {

                        //options.content = template.FK_templates_tl_templates[0].html;
                        toastr.error("Ha ocurrido un error, no se encuentra el template original");

                    }
                });
            } else {
                $scope.mail.content = "";
            }
        }

        $scope.openDocumentsModal = function (document_code) {
            if (document_code != null && document_code != "") {
                var params = {
                    entity_type: (options.params.entity_type != null ? options.params.entity_type : null),
                    entity_type_id: (options.params.entity_type_id != null ? options.params.entity_type_id : null),
                    documents: { codes: [document_code] }
                };
                generateDocumentService.documentNew({
                    params: params,
                    onAccept: function (data) {
                        //se lo añadimos a los files....
                        var doc = {name: data[0].document_name}
                        $scope.mail.filesToShow.unshift(doc);
                        $scope.mail.notificationAttachments.unshift({ name: data[0].document_name, entity_type: data[0].document_type_code, entity_type_id: data[0].document_id, uid: data[0].uid })
                        $scope.mail.document_code = null;
                    }
                });
            }
        }

        $scope.refreshRecipients = function() {

            $http({
                method: 'post',
                url: (window as any).CONFIG.api_url + 'NotificationsEmails/GetRecipientMails',
                data: $scope.mail
            }).then(function (results, status, headers, config) {
                let arr = [];
                switch (results.data.entity_type) {
                    case "persons":
                        $scope.recipientData = results.data.persons_ids_mails;
                        break;
                    case "users":
                        $scope.recipientData = results.data.users_ids_mails;
                        break;
                    case "accreditation_staff":
                        $scope.recipientData = results.data.event_staffs_ids_mails;
                        break;
                    default:
                        $scope.recipientData = results.data.event_guests_ids_mails;
                        break;
                }
                
            });
        };

        $scope.showRecipients = function() {
            $scope.showRecipientList = !$scope.showRecipientList;
            if($scope.showRecipientList) {
                $scope.refreshRecipients();
            }
        };

        $scope.mailingChange = function (mailing_id) {
            Restangular.one('Mailings', mailing_id).get().then(function (result) {
                $scope.mail.subject = result.subject;
                $scope.mail.preheader = result.preheader;
                $scope.mail.mail_from = result.mail_account_id;
                $scope.mail.mail_account_id = result.mail_account_id;
                $scope.mail.cco_tmp = result.cco;
                $scope.mail.ics = result.ics;
                $scope.mail.template_id = result.template_id;
                $scope.options.template = result.FK_mailing_template;
                $scope.mail.content = result.content;
                $scope.mail.filesToShow = [];
                $scope.mail.files = [];
                $scope.mail.attachments = [];
                $scope.mail.notificationAttachments = [];
                //$scope.loadTemplate($scope.mail.template_id);
                $scope.blocked_all = true;
                
                if(result.json != null && result.json !== "") {
                    $scope.loadBee = true;
                    BeeService.reload(JSON.parse(result.json));
                } else {
                    $scope.loadBee = false;
                }
                
                $scope.mailing = result;
                $scope.changeReplies(false);

                $scope.mailing.filesToShow = [];
                if (result.FK_mailing_attachment_mailing.length > 0) {
                    angular.forEach(result.FK_mailing_attachment_mailing, function (row) {
                        if (row.document_id == 0 || row.document_id ==null) {
                            $http({
                                method: 'get',
                                url: (window as any).CONFIG.api_url + 'MailingsAttachment/getFile?uid=' + row.uid + "&filename=" + row.name+"&file_id="+row.file_id,
                                responseType: 'arraybuffer'
                            }).then(function (results, status, headers, config) {

                                var contentType = row.mimetype;
                                var filename = row.name;

                                var file = new Blob([results], { type: contentType });

                                file['name'] = filename;

                                $scope.mail.files.push(file);

                            });
                        } else {
                            Restangular.one("Documents", row.document_id).get().then(function (res){
                                $scope.mail.notificationAttachments.unshift({ name: row.name, entity_type: res.FK_documents_documents_types.code, entity_type_id: row.document_id })
                            });
                            
                        }

                        $scope.mail.filesToShow.push(row);                   
                    });
                }
            });
        }

    }]);
